import { UserCallInfo } from "@fidget/common/services/AbstractCallService";
import { flow, Instance } from "mobx-state-tree";
import { CallModel, CallState } from "@fidget/common/models/call/callModel";
import { mediaDevicesService } from "@fidget/common/services/mediaDevicesService";
import { MediaService } from "@fidget/common/services/mediaService";
import { logger } from "@fidget/common/utils";
import { servicesGetters } from "../utils";

export const CallStore = CallModel.named("CallStore")
  .views(servicesGetters)
  .actions((self) => {
    const mediaService = MediaService.getInstance();

    return {
      answer: flow(function* () {
        if (!self.isConnecting || !self.callId) {
          logger.debug("CallStore: no call to answer");
          return;
        }

        logger.debug("CallStore: answer");
        const track = yield mediaService.getMicrophoneTrack();
        if (track) {
          self.localMicrophone.setMediaStreamTrack(track);
          self.localMicrophone.enable();
          yield self.callService.answer({ callId: self.callId }, track);
          self.state = CallState.IN_PROGRESS;
          self.startTimestamp = Date.now();
        } else {
          // check if microphone permission was rejected
          const perms = yield mediaDevicesService.reloadPermissions();
          if (!perms.isWebsiteHasMicrophonePermissions) {
            self.localMicrophone.denyPermission();
          }
        }
      }),

      hangup: flow(function* () {
        if (!self.isNoCall && self.callId) {
          logger.debug("CallStore: hangup");
          yield self.state === CallState.IN_PROGRESS
            ? self.callService.leave({ callId: self.callId })
            : self.callService.reject({ callId: self.callId });
        }
      })
    };
  })
  .actions((self) => {
    return {
      handleIncomingCall(incomingCall: UserCallInfo) {
        if (self.isNoCall) {
          self.stopMediaDevices();
          self.handleConnecting(incomingCall);
        } else {
          logger.error("New call incoming when old is not ended, ignoring", incomingCall);
        }
      }
    };
  })
  .actions((self) => {
    return {
      afterCreate() {
        self.callService.received$.subscribe((incomingCall) =>
          self.handleIncomingCall(incomingCall)
        );
      }
    };
  });

export interface ICallStore extends Instance<typeof CallStore> {}
